import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory,
  useLocation,
  useRouteMatch,
  useParams,
} from 'react-router-dom';
import styled from 'styled-components';
import { SpaceTabDocumentType } from 'api/space/space-tab';
import { Page } from 'components/molecules/page';
import { SpaceTab } from 'data/space-tabs';
import {
  useProjectTemplateSpace,
  setupActiveSpaceTab,
} from 'data/templates/projects';
import { selectActiveSpaceTabId } from 'data/templates/projects/selectors';
import { ProjectSpaceTemplateNewTabPaneContent } from './new-tab-pane';
import {
  TemplateSpacesEmbeddedDocument,
  TemplateRocketlaneDocumentTabContent,
} from './tab-contents';

export const NewItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  overflow: auto;
`;

const PageWrapper = styled(Page)`
  height: 100%;
  border-top: 1px solid var(--coolest-gray-10);
  overflow: hidden;
`;

export const ProjectTemplateTabDetail: FC = () => {
  const { spaceId } =
    useParams<{
      spaceId: string;
    }>();

  const dispatch = useDispatch();
  const history = useHistory();
  const activeSpace = useProjectTemplateSpace(parseInt(spaceId, 10));
  const { url } = useRouteMatch();
  const location = useLocation();
  const defaultActiveKey = location.pathname.replace(`${url}/tabs/`, '');
  const value = useSelector(selectActiveSpaceTabId());

  useEffect(() => {
    if (
      defaultActiveKey !== 'new' &&
      (activeSpace?.spaceTabs || []).findIndex(
        (spaceTab) => spaceTab.spaceTabId === parseInt(defaultActiveKey, 10),
      ) < 0
    ) {
      history.replace(`${url}/tabs/new`);
    }
  }, [activeSpace, defaultActiveKey, history, url]);

  useEffect(() => {
    dispatch(
      setupActiveSpaceTab({
        spaceTabId:
          defaultActiveKey !== 'new' ? parseInt(defaultActiveKey, 10) : null,
      }),
    );
  }, [defaultActiveKey, dispatch]);

  return activeSpace ? (
    <PageWrapper>
      {value === null ? (
        <NewItem>
          <ProjectSpaceTemplateNewTabPaneContent
            spaceId={parseInt(spaceId, 10)}
          />
        </NewItem>
      ) : (
        <>
          {activeSpace.spaceTabs.map((spaceTab) => {
            if (spaceTab.spaceTabId === value) {
              return (
                <>
                  {spaceTab.spaceTabType ===
                  SpaceTabDocumentType.RocketlaneDocument ? (
                    <TemplateRocketlaneDocumentTabContent
                      data={spaceTab as unknown as SpaceTab}
                      spaceId={parseInt(spaceId, 10)}
                    />
                  ) : (
                    <TemplateSpacesEmbeddedDocument
                      data={spaceTab as unknown as SpaceTab}
                      spaceId={parseInt(spaceId, 10)}
                    />
                  )}
                </>
              );
            }

            return <></>;
          })}
        </>
      )}
    </PageWrapper>
  ) : (
    <></>
  );
};
